module.exports = __webpack_public_path__ + "static/media/blockscan.8da0981f.png";